<template>
	<div class="frame">
		<div class="paragraph-background">
			<div class="heading">{{ headTxt }}</div>
			<div class="time-wrapper">{{ currentTime }}</div>
		</div>
		<div class="info-background" v-if="$vuetify.breakpoint.smAndUp">
			<div class="info-text" style="font-size: 18px;">
				대기번호가 지나가면 재신청이 필요합니다. 추가 대기시간이 발생하오니 알림톡 또는 문자를 꼭 확인해주세요.
			</div>
		</div>

		<div class="main-container">
			<div class="current-section">
				<div class="current-label" v-if="waitings[0] && waitings[0].Num">
					대기번호
				</div>
				<div class="current-number">
					{{ waitings[waitings.filter(x => x.Num).length - 1] ? waitings[waitings.filter(x => x.Num).length - 1].Num : '' }}
				</div>
				<div class="counter-info">
					<div class="status-dot"></div>
					<div class="counter-text">
						{{
							waitings[waitings.filter(x => x.Num).length - 1] && waitings[waitings.filter(x => x.Num).length - 1].seat
								? waitings[waitings.filter(x => x.Num).length - 1].seat + '번 상담석'
								: $route.name === 'board_new'
								? '대기중'
								: '상담대기 ZONE 으로 이동해주세요'
						}}
					</div>
				</div>
			</div>

			<div class="waiting-section">
				<div class="waiting-list-section">
					<div class="waiting-headers">
						<div class="waiting-header">대기번호</div>
						<div class="waiting-header" style="margin-left: auto;">상담석</div>
					</div>

					<div class="waiting-list">
						<div
							v-for="(waiting, i) in waitings.filter(w => w.Num !== '').slice(0, 10)"
							:key="i"
							class="waiting-item"
							:class="{ 'first-item': true }"
						>
							<div class="waiting-number">{{ waiting.Num }}</div>
							<div class="counter-assignment">
								<v-layout class="waiting-number" align-center justify-center>
									{{ waiting.seat ? waiting.seat + '번' : '대기중' }}
									<div class="info-text-waiting" v-show="waiting.seat">상담석</div>
								</v-layout>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<alertModal2 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal2 } from '@/components/index'
export default {
	components: {
		alertModal2,
	},
	data() {
		return {
			currentTime: '',
			timeInterval: null,
			waitNum: 0,
			serverUrl: '',
			headTxt: 'URL을 확인해주세요.',
			logoUrl: '',
			waitings: [
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
			],
			screenWidth: 0,
			voiceList: [], // 음성 재생 데이터
			greetingSpeech: new window.SpeechSynthesisUtterance(),
			synth: window.speechSynthesis,
			called: [], // call한 고객 Data
			bottomSlice: 0, // 하단 상담석 리스트 slice point
			bottomEnd: 0,
			calledUser: { seat: '', waitnum: '' }, // 현재 부른 고객
			counselorData: [], // 카운셀러 데이터
			socket: '',
			waitingsListViews: [],
			alertModal2: {
				dialog: false,
				text: '띵동 소리 활성화를 위하여 클릭해주세요.',
			},
		}
	},
	async mounted() {
		this.updateTime()
		this.timeInterval = setInterval(this.updateTime, 1000)

		await this.reservedays()
		await this.waitingsSocket()
		this.alertModal2.dialog = true
		const audio = new Audio('/tingtong.wav')

		// 자동재생 가능 여부 체크
		try {
			// 음소거 상태로 시도
			// audio.muted = true
			await audio.play()

			// 성공하면 음소거 해제 시도
			// audio.muted = false
		} catch (error) {
			// 실패 시 사용자 인터랙션 대기
			// this.voice(0)
		}
	},
	created() {
		this.screenWidth = window.innerWidth

		this.voiceList = this.synth.getVoices()

		this.synth.onvoiceschanged = () => {
			this.voiceList = this.synth.getVoices()
		}
	},
	beforeDestroy() {
		if (this.timeInterval) {
			clearInterval(this.timeInterval)
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		updateTime() {
			this.currentTime = this.$moment(new Date()).format('YYYY년 MM월 DD일 HH:mm:ss')
		},
		async waitingsSocket() {
			setInterval(() => {
				const data = {
					code: this.$route.params.code,
					stat: this.$route.name === 'board_new' ? 1 : 0,
					seat_ne: this.$route.name === 'board_new' ? 0 : undefined,
					seat_null: this.$route.name === 'board_new' ? false : undefined,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
					limit: 10,
				}
				this.$store.dispatch('waitings', data).then(res => {
					if (res.data.waitings.length === 0) {
						if (this.counselorData.length >= 10) {
							this.waitings = [
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
							]
						} else {
							this.waitings = []
							this.counselorData.forEach(() => {
								this.waitings.push({ seat: null, Num: '' })
							})
						}
					} else {
						const setData = res.data.waitings
						setData.forEach((element, i) => {
							if (i < 10) {
								this.waitings[i].seat = element.seat
								this.waitings[i].Num = element.waitingnum
							}
							let called = this.called.findIndex(e => e === Number(element.waitingnum))
							if (called === -1) {
								this.called.push(Number(element.waitingnum))
								this.calledUser.seat = element.seat
								this.calledUser.waitnum = element.waitingnum
								// var tingtong = new Audio('/tingtong.wav')
								// tingtong.play()
								setTimeout(() => {
									this.voice(setData.length - 1)
								}, 3000)
							}
						})
						let rest = this.waitings.length - res.data.waitings.length
						if (rest > 0) {
							for (let index = res.data.waitings.length; index < this.waitings.length; index++) {
								this.waitings[index].seat = null
								this.waitings[index].Num = ''
							}
						}
					}
				})
				const data_count = {
					code: this.$route.params.code,
					seat: 0,
					stat: 0,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
					limit: 10,
				}
				// this.$store.dispatch('waitings', data).then(res => {
				this.$store.dispatch('waitingsConnection', data_count).then(res => {
					const waitingsPeople = res.data.waitingsConnection.aggregate.count
					this.waitNum = waitingsPeople
				})
			}, 1500)
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store.dispatch('reservedays', data).then(res => {
				this.headTxt = res.data.reservedays[0].title
				if (res.data.reservedays[0].business.QRlogo) {
					this.logoUrl = res.data.reservedays[0].business.QRlogo.url
				}
				const data = {
					business: res.data.reservedays[0].business.id,
				}
				this.$store.dispatch('counselors', data).then(res => {
					let counselorList = []
					this.counselorData = res.data.counselors
					if (res.data.counselors.length <= 10) {
						this.waitings = [
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
						]

						this.bottomEnd = 10
						this.bottomSlice = 5
					} else {
						res.data.counselors.forEach(() => {
							counselorList.push({ seat: null, Num: '' })
						})
						this.waitings = counselorList
						this.bottomSlice = Math.ceil(this.waitings.length / 2)
						this.bottomEnd = this.waitings.length
						if (this.waitings.length % 2 === 1 && this.screenWidth < 1090) {
							this.waitings.push({ seat: null, Num: '' })
							this.bottomEnd = this.bottomEnd + 1
						}
					}
				})
			})
		},
		waitingsList() {
			const data = {
				code: this.$route.params.code,
				stat: 0,
				// seatcall: 0,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				limit: 5,
			}
			this.$store
				.dispatch('waitingNumber', data)
				.then(res => {
					this.waitingsListViews = res.data.waitings
				})
				.catch(() => {})
		},

		voice(i) {
			i
			// tingtong 사운드 재생
			const tingtong = new Audio('/tingtong.wav')
			tingtong.play().catch(err => {
				console.error('띵동 소리 재생 실패:', err)
			})

			// TTS 설정
			const speeh = new window.SpeechSynthesisUtterance()
			speeh.text = '대기번호' + this.waitings[i].Num + '번 고객님 상담석' + this.waitings[i].seat + '번으로 와주시기 바랍니다'

			// 한국어 음성 찾기 (여러 옵션 시도)
			let voiceIndex = -1
			const koreanVoiceNames = [
				'Google 한국의',
				'Microsoft Heami - Korean (Korean)',
				'Microsoft Heami',
				'Heami',
				'Yuna',
				'Korean Female',
				'Korean Male',
				'ko-KR',
			]

			// 여러 한국어 음성 이름 중 첫 번째로 찾은 것 사용
			for (let voiceName of koreanVoiceNames) {
				voiceIndex = this.voiceList.findIndex(e => e.name.includes(voiceName) || e.lang === 'ko-KR' || e.lang === 'ko')
				if (voiceIndex !== -1) break
			}

			// 한국어 음성을 찾지 못한 경우 기본 음성 사용
			if (voiceIndex !== -1) {
				speeh.voice = this.voiceList[voiceIndex]
			} else {
				// 한국어 음성이 없으면 첫 번째 사용 가능한 음성 사용
				if (this.voiceList.length > 0) {
					speeh.voice = this.voiceList[0]
					console.warn('한국어 음성을 찾을 수 없어 기본 음성을 사용합니다.')
				}
			}

			// 음성 속도 및 볼륨 설정 (태블릿 호환성 개선)
			speeh.rate = 0.9 // 약간 느리게
			speeh.pitch = 1.0
			speeh.volume = 1.0

			// 음성 재생 시도
			try {
				// 이전 음성이 재생 중이면 취소
				if (window.speechSynthesis.speaking) {
					window.speechSynthesis.cancel()
				}

				window.speechSynthesis.speak(speeh)

				// 음성 재생 이벤트 리스너 추가 (디버깅용)
				speeh.onstart = () => {
					console.log('음성 재생 시작')
				}
				speeh.onend = () => {
					console.log('음성 재생 완료')
				}
				speeh.onerror = event => {
					console.error('음성 재생 오류:', event.error)
					// 오류 발생 시 대체 알림 방법 사용
					// this.showVisualAlert(i)
				}
			} catch (error) {
				console.error('TTS 실행 오류:', error)
				// TTS 실패 시 시각적 알림으로 대체
				// this.showVisualAlert(i)
			}
		},

		// 시각적 알림 메서드 추가 (TTS 실패 시 대체용)
		showVisualAlert(i) {
			// alertModal2를 사용하여 알림 표시
			this.alertModal2.text = `대기번호 ${this.waitings[i].Num}번 고객님, 상담석 ${this.waitings[i].seat}번으로 와주시기 바랍니다`
			this.alertModal2.dialog = true

			// 5초 후 자동으로 닫기
			setTimeout(() => {
				this.alertModal2.dialog = false
			}, 5000)
		},
	},
}
</script>

<style>
html {
	overflow: hidden !important;
}
</style>
<style lang="scss" scoped>
// Component-specific reset for this page only
.frame {
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
}

// Make html overflow hidden when this component is active
:global(html) {
	overflow: hidden !important;
}

@keyframes blink {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.3;
	}
}

@keyframes moveDash {
	0% {
		background-position: 0 0;
	}
	100% {
		background-position: 20px 0;
	}
}

@keyframes glow {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.8;
	}
}

@keyframes slideIn {
	from {
		transform: translateY(-10px);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.status-dot {
	width: 24px;
	height: 24px;
	background: #00ff88;
	border-radius: 50%;
	margin-right: 20px;
	animation: blink 1s ease-in-out infinite;
}

.frame {
	font-family: 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
	background-color: #0a0a0a;
	height: 100vh;
	overflow-y: auto;
	color: #ffffff;
	position: relative;
	width: 100%;
}
.info-background {
	background-color: #000000;
	height: 30px;
	left: 0;
	position: absolute;
	top: 70px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 28px;
}
.paragraph-background {
	background-color: #000000;
	height: 70px;
	left: 0;
	position: absolute;
	top: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 28px;
}

.heading {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 56px;
	font-weight: 300;
	letter-spacing: -2px;
	line-height: normal;
	white-space: nowrap;
}

.time-wrapper {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 36px;
	font-weight: 200;
	letter-spacing: 0;
	text-align: center;
}

.main-container {
	position: absolute;
	top: 121px;
	left: 30px;
	right: 30px;
	bottom: 30px;
	display: flex;
	gap: 30px;
}

.current-section {
	background-color: #1a1a1a;
	border-radius: 30px;
	overflow: hidden;
	position: relative;
	flex: 3;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 15px;
		right: 15px;
		height: 2px;
		background: linear-gradient(90deg, #00ff88, #00ff88 50%, transparent 50%);
		background-size: 20px 2px;
		animation: moveDash 1s linear infinite;
	}
}

.current-label {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 64px;
	font-weight: 400;
	letter-spacing: 2px;
	margin-bottom: 40px;
	margin-top: 80px;
}

.current-number {
	color: #00ff88;
	font-family: 'Inter', Helvetica;
	font-size: 360px;
	font-weight: 700;
	letter-spacing: 0;
	text-shadow: 0px 0px 40px rgba(0, 255, 136, 0.5);
	animation: glow 2s ease-in-out infinite;
	margin: 20px 0;
	line-height: 300px;
}

.counter-info {
	display: flex;
	align-items: center;
	background-color: #2a2a2a;
	border-radius: 50px;
	padding: 20px 60px;
	margin-top: 40px;
	margin-bottom: 80px;
}

.counter-text {
	color: #00ff88;
	font-family: 'Inter', Helvetica;
	font-size: 100px;
	font-weight: 400;
	letter-spacing: 0;
}

.waiting-section {
	background-color: #1a1a1a;
	border-radius: 30px;
	position: relative;
	flex: 1;
	min-width: 331px;
	padding: 13px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 15px;
		right: 15px;
		height: 4px;
		background: linear-gradient(90deg, #00ff88, #00ff88 50%, transparent 50%);
		background-size: 20px 4px;
		animation: moveDash 1s linear infinite;
	}
}

.waiting-count-section {
	background-color: rgba(255, 170, 0, 0.1);
	border: 2px solid #00ff88;
	border-radius: 10px;
	height: 181px;
	margin-bottom: 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.waiting-count-label {
	background-color: #00ff88;
	border-radius: 15px;
	padding: 8px 18px;
}

.waiting-count-label-text {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 30px;
	font-weight: 400;
	letter-spacing: 0;
}

.waiting-count-number {
	color: #00ff88;
	font-family: 'Inter', Helvetica;
	font-size: 56px;
	line-height: 64px;
	font-weight: 700;
	letter-spacing: 0;
	margin-top: 10px;
}

.waiting-list-section {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.waiting-headers {
	display: flex;
	margin-bottom: 14px;
	padding-left: 3px;
}

.waiting-header {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 30px;
	font-weight: 400;
	letter-spacing: 2px;
	text-align: center;

	&:first-child {
		width: 149px;
	}

	&:last-child {
		width: 149px;
	}
}

.waiting-list {
	flex: 1;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 10px;
	height: 450px;
}

.waiting-item {
	background-color: #2a2a2a;
	border-radius: 10px;
	height: 61px;
	display: flex;
	align-items: center;
	padding: 0 16px;
	transition: all 0.5s ease;
	transform: translateY(0);
	opacity: 1;

	&:nth-child(1) {
		animation: slideIn 0.5s ease-out;
	}

	&:nth-child(2) {
		animation: slideIn 0.5s ease-out 0.1s both;
	}

	&:nth-child(3) {
		animation: slideIn 0.5s ease-out 0.2s both;
	}

	&:nth-child(4) {
		animation: slideIn 0.5s ease-out 0.3s both;
	}

	&:nth-child(5) {
		animation: slideIn 0.5s ease-out 0.4s both;
	}

	&:nth-child(6) {
		animation: slideIn 0.5s ease-out 0.5s both;
	}

	&.first-item {
		background-color: rgba(255, 170, 0, 0.1);
		border: 2px solid #00ff88;
		height: 63px;

		.waiting-number {
			color: #00ff88;
			white-space: nowrap;
		}
		& .info-text-waiting {
			font-size: 20px !important;
			padding-left: 4px !important;
		}

		.counter-assignment {
			background-color: rgba(255, 170, 0, 0.1);
			border: none;
		}

		.counter-assignment-text {
			color: #00ff88;
		}
	}
}

.waiting-number {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 38px;
	font-weight: 700;
	letter-spacing: 0;
	width: 103px;
	text-align: center;
}

.counter-assignment {
	background-color: #1a1a1a;
	border: 1px solid #333333;
	border-radius: 15px;
	height: 45px;
	width: 180px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: auto;
}

.counter-assignment-text {
	color: #ffffff;
	font-family: 'Inter', Helvetica;
	font-size: 28px;
	font-weight: 400;
	letter-spacing: 0;
}

/* 반응형 스타일 */
@media (max-width: 1200px) {
	.heading {
		font-size: 48px;
	}

	.time-wrapper {
		font-size: 28px;
	}

	.current-number {
		line-height: 280px;
		font-size: 280px;
	}

	.current-label {
		font-size: 48px;
	}

	.counter-text {
		font-size: 48px;
	}
}

@media (max-width: 1090px) {
	.main-container {
		flex-direction: column;
		gap: 20px;
	}

	.current-section {
		flex: 1;
		min-height: 460px;
	}

	.waiting-section {
		flex: 1;
		min-width: auto;
	}

	.current-number {
		line-height: 200px;
		font-size: 200px;
	}

	.current-label {
		font-size: 40px;
		margin-top: 40px;
		margin-bottom: 20px;
	}

	.counter-text {
		font-size: 36px;
	}

	.counter-info {
		display: flex;
		align-items: center;
		padding: 15px 40px;
		margin-top: 20px;
		margin-bottom: 40px;
	}
}

@media (max-width: 768px) {
	.heading {
		font-size: 32px;
	}

	.time-wrapper {
		font-size: 18px;
	}

	.current-number {
		line-height: 120px;
		font-size: 120px;
	}

	.current-label {
		font-size: 28px;
	}

	.counter-text {
		font-size: 24px;
	}

	.waiting-header {
		font-size: 20px;
	}

	.waiting-number {
		font-size: 18px;
	}

	.counter-assignment-text {
		font-size: 16px;
	}

	.waiting-count-number {
		font-size: 48px;
	}

	.waiting-count-label-text {
		font-size: 20px;
	}
}
</style>
